module.exports = __webpack_public_path__ + "fbb6ca1fddb98d1a3f67c8a57c5029da.svg";